import DeviceHealthContainer from '~/modules/devices/containers/DeviceHealthContainer';
import { usePageTitle } from '~components/DashboardWrapper/PageTitle';
import { t } from '~/i18n';

export default function DeviceHealthPage() {
  usePageTitle(t('menu.dashboard.deviceHealth'));
  return <DeviceHealthContainer />;
}
